import type { CrudState, MutationClass } from '../../../models'

export class SetStateMutation implements MutationClass {
  static execute(this: void, state: CrudState, newState: Partial<CrudState>): void {
    Object.assign(state, newState)
  }
}
